// import isUndefined from 'lodash/isUndefined';

// import { renderCurrency } from '../../components/SystemCountry';

// import getFilterWithCol from '../../helpers/getFilterWithCol';

import { createDefaultFields } from './helpers';

import tests from '../../helpers/tests';

// import { createChangeLogSection } from '../../components/FieldChangeLog';

// import Types from '../../modules/types';

const { viewerIsNotAdmin } = tests;

export default [
  'PageSingle',
  {
    // icon: 'tool',
    path: '/settings/product-gallery-generate',
    title: 'Product Gallery Generate',
    headerTitle: 'Product Gallery Generate',
    renderHeaderTitle: () => 'Product Gallery Generate',
    hidden: false,
    activity: 'edit',
    url: '/settings/productGalleryGenerate',
    redirect: [['redirect.unauthorized']],
    actions: [['ActionSave']],
    skip: [viewerIsNotAdmin],
    fields: createDefaultFields(),
  },
];
